import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-recovery-page',
  templateUrl: './password-recovery-page.component.html',
  styleUrls: ['./password-recovery-page.component.scss'],
})
export class PasswordRecoveryPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
